import { ref } from 'vue'
import type { WebOrderPayment } from '@orders'

const previousPayment = ref<WebOrderPayment | null>(null)

export function useShopPayPreviousPayment() {
  function saveIfNotShopPay(pmt: WebOrderPayment | null | undefined) {
    if (pmt && pmt.paymentType !== 'shopPay') {
      previousPayment.value = JSON.parse(JSON.stringify(pmt))
    }
  }

  return { previousPayment, saveIfNotShopPay }
}
